module.exports = __webpack_public_path__ + "fonts/tt_sushkof_bold.d4415e3.woff";